import { createNamespacedHelpers } from 'vuex-composition-helpers';
const { useState } = createNamespacedHelpers('client');
export const useClient = () => {
    const { details } = useState(['details']);
    return { client: details };
};
